/*
 * Poly2Tri Copyright (c) 2009-2014, Poly2Tri Contributors
 * http://code.google.com/p/poly2tri/
 *
 * poly2tri.js (JavaScript port) (c) 2009-2014, Poly2Tri Contributors
 * https://github.com/r3mi/poly2tri.js
 *
 * All rights reserved.
 *
 * Distributed under the 3-clause BSD License, see LICENSE.txt
 */

import { type XY, toString } from './xy'

/**
 * Custom exception class to indicate invalid Point values
 */
export class PointError extends Error {
	points: XY[]

	constructor(message?: string, points: XY[] = []) {
		let msg = message || 'Invalid Points!'
		for (const point of points) {
			msg += ' ' + toString(point)
		}
		super(msg)
		this.name = 'PointError'
		this.points = points
		// Maintains proper stack trace for where our error was thrown (only available on V8)
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, PointError)
		}
	}
}

